'use strict';

$(function () {
  // $('.js-vn_offer-conditions').hide()
  // $('.js-financial-conditions').addClass('active')
  // // Toggle open and close nav styles on click        
  // $('.js-financial-conditions').on('click', function (e) {
  //   e.preventDefault()
  //   $(this).toggleClass('active')
  //   $(this).closest('article').find('.js-vn_offer-conditions').slideToggle()
  // })

  // Toggle open and close nav styles on click
  $('.js-equiped').on('click', function (e) {
    e.preventDefault();
    if ($(window).width() < 576) {
      $(this).toggleClass('active');
      $(this).closest('article').find('.js-characteristics').slideToggle();
    }
  });

  // $('.js-vn_offer-conditions').each(function () {

  //   let legal = $(this).clone()
  //   legal.attr('id', legal.data('legal'))
  //   $('.main').append(legal)
  // })
});